import { useDispatch } from 'react-redux';
import storage from 'redux-persist/es/storage';
import { type AppDispatch } from './types.js';

export const useAppDispatch: () => AppDispatch = useDispatch; // Export a hook that can be reused to resolve types

export const useRemoveAuthPersist: () => () => Promise<void> = () => () => storage.removeItem('persist:auth');
